var AUTH_PROVIDER_GET_ACCESS_TOKEN_START = 'AUTH_PROVIDER_GET_ACCESS_TOKEN_START';
var AUTH_PROVIDER_GET_ACCESS_TOKEN_ERROR = 'AUTH_PROVIDER_GET_ACCESS_TOKEN_ERROR';
var AUTH_PROVIDER_GET_ACCESS_TOKEN_END = 'AUTH_PROVIDER_GET_ACCESS_TOKEN_END';
var STATUSES = {
    authProviderExchange: {
        AUTH_PROVIDER_GET_ACCESS_TOKEN_START: AUTH_PROVIDER_GET_ACCESS_TOKEN_START,
        AUTH_PROVIDER_GET_ACCESS_TOKEN_ERROR: AUTH_PROVIDER_GET_ACCESS_TOKEN_ERROR,
        AUTH_PROVIDER_GET_ACCESS_TOKEN_END: AUTH_PROVIDER_GET_ACCESS_TOKEN_END
    }
};
var MSHeaders = {
    CORRELATION_ID: 'x-ms-correlationid',
    REQUEST_ID: 'x-ms-requestid',
    CLIENT_NAME: 'x-ms-client-name',
    APP: 'x-ms-app',
    API_KEY: 'x-api-key'
};
var FALLBACK_LANGUAGE = 'en';
var CATALOG_SUPPORTED_LANGUAGES = [
    'es',
    'nl',
    'ko',
    'cs',
    'ru',
    'zh-hans',
    'fr',
    'zh-hant',
    'en',
    'pt-br',
    'it',
    'sv',
    'de',
    'tr',
    'hu',
    'pl',
    'pt-pt',
    'ja'
];

export { CATALOG_SUPPORTED_LANGUAGES, FALLBACK_LANGUAGE, MSHeaders, STATUSES };
